import { ServiceDefinition } from "@pershing/pershing-core";
import { PortalComponentConstants } from "../utils/portal-component.constants";


export class AlertServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;
    uri: string = '';
    version: string = '';
    name = PortalComponentConstants.ALERT_API_CONTEXT;

    private constructor() {};

    static getInstance():ServiceDefinition {
        if(!AlertServiceDefinition.instance) {
            AlertServiceDefinition.instance = new AlertServiceDefinition();
        }
        return AlertServiceDefinition.instance;
    }
}